import styled from "styled-components";

export const resetButtonStyles = `
// reset button styles so can use for better a11y
border: 0;
background-color: transparent;
text-align: left;
padding: 0;
`;

const ResetButton = styled.button`
  ${resetButtonStyles}
`;

export default ResetButton;
